import { render, staticRenderFns } from "./horizontal-list.vue?vue&type=template&id=22c41013&scoped=true"
import script from "./horizontal-list.vue?vue&type=script&lang=js"
export * from "./horizontal-list.vue?vue&type=script&lang=js"
import style0 from "./horizontal-list.vue?vue&type=style&index=0&id=22c41013&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c41013",
  null
  
)

export default component.exports